import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Unstable_Grid2 as Grid,
} from '@mui/material';
import { useFormikContext } from 'formik';
import { useTheme } from '@mui/material/styles';

import { ManualNotificationEmailFormat, ManualNotificationsItemUpdateInput } from 'api';
import { ValidatedTextFieldNext } from 'components';
import { EMPTY_SLATE_EDITOR } from 'app-constants';

import SlateEditor from 'components/SlateEditor';

const EmailInput: FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const { values, setFieldValue } = useFormikContext<ManualNotificationsItemUpdateInput>();

  const { message, email } = values;
  const hasEmail = !!email;
  const emailBodyFieldName = 'email.body';

  function toggleEmail() {
    const emailValues = {
      format: ManualNotificationEmailFormat.Html,
      subject: email?.subject || message?.body || '',
      body: email?.body ?? EMPTY_SLATE_EDITOR,
    };

    const value = hasEmail ? null : emailValues;
    setFieldValue('email', value);
  }

  function renderFields() {
    if (!hasEmail) {
      return null;
    }

    return (
      <Grid container>
        <Grid xs={12} marginBottom={4}>
          <ValidatedTextFieldNext
            fullWidth
            color="primary"
            name="email.subject"
            label={t('messages:subject')}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid xs={12}>
          <SlateEditor
            fieldName={emailBodyFieldName}
            label={t('messages:message')}
            placeholder={t('messages:composeEmail')}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Fragment>
      <FormControl variant="standard" margin="normal">
        <FormControlLabel
          label={t('messages:sendEmailNotifications')}
          control={<Checkbox checked={hasEmail} onChange={toggleEmail} />}
          sx={{
            marginLeft: -1,
            fontSize: 14,
            fontWeight: hasEmail
              ? theme.typography.fontWeightBold
              : theme.typography.fontWeightRegular,
          }}
        />
      </FormControl>
      <Box paddingTop={1} paddingX={8} paddingBottom={0}>
        {renderFields()}
      </Box>
    </Fragment>
  );
};

export default EmailInput;
